// Func = limiting Scope for this file
var lastScrollTop = 0;

//datepicker booking
var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0;

if( document.querySelector( "#form_id-1646" ) ){

	let select_a_destination = document.querySelectorAll( "input[name*='select_destination']" )

	let _access_token = document.createElement( "input" );
	_access_token.type = "hidden"
	_access_token.name = "_access_token"
	_access_token.value = "07d403fb-d10e-4632-8cb5-54aa1c58b2c1,5e386655-ea24-4a74-9e08-98c65aaa5a2e,";
	document.querySelector( "#form_id-1646" ).appendChild( _access_token );

	select_a_destination.forEach( ( item, index ) => {

		item.addEventListener( "change", ( e ) => {

			if( e.target.checked ){
				switch( e.target.value ){
					case "Paséa Hotel & Spa":
						_access_token.value += "9b1f4a98-d3cc-4212-8500-893725ef3ac5,2d84b561-d52b-40e5-ad95-ef1130113e8e,";
						break;
					case "The Meritage Resort and Spa":
						_access_token.value += "973918ca-d119-44d5-a71f-3eda76b2faa6,2be376f6-1c1d-4bf9-9442-b2875796e11f,";
						break;	
					case "Koa Kea Hotel & Resort":
						_access_token.value += "28ac6b7e-5d0e-4698-ae2f-5d457005e440,4ebe5fdc-13e1-4763-bc66-7ae643a0c62b,";
						break;
					case "Hotel Viata":
						_access_token.value += "07d403fb-d10e-4632-8cb5-54aa1c58b2c1,5e386655-ea24-4a74-9e08-98c65aaa5a2e,";
						break;
					case "Grand Reserve":	
						_access_token.value += "973918ca-d119-44d5-a71f-3eda76b2faa6,2be376f6-1c1d-4bf9-9442-b2875796e11f,";
						break;
				}
			}else{

				let value = _access_token.value;
				switch( e.target.value ){
					case "Paséa Hotel & Spa":
						_access_token.value = value.replace("9b1f4a98-d3cc-4212-8500-893725ef3ac5,2d84b561-d52b-40e5-ad95-ef1130113e8e,", "") ;
						break;
					case "The Meritage Resort and Spa":
						_access_token.value = value.replace("973918ca-d119-44d5-a71f-3eda76b2faa6,2be376f6-1c1d-4bf9-9442-b2875796e11f,", "") ;
						break;	
					case "Koa Kea Hotel & Resort":
						_access_token.value = value.replace("4ebe5fdc-13e1-4763-bc66-7ae643a0c62b,28ac6b7e-5d0e-4698-ae2f-5d457005e440,", "") ;
						break;
					case "Hotel Viata":
						_access_token.value = value.replace("07d403fb-d10e-4632-8cb5-54aa1c58b2c1,5e386655-ea24-4a74-9e08-98c65aaa5a2e,", "") ;
						break;
					case "Grand Reserve":	
						_access_token.value = value.replace("973918ca-d119-44d5-a71f-3eda76b2faa6,2be376f6-1c1d-4bf9-9442-b2875796e11f,", "");
						break;	
				}		

			}

		} )

	} )
}	

if( document.querySelector( "#form_id-3255" ) ){

	let select_a_destination = document.querySelectorAll( "input[name*='interests']" )

	let _access_token = document.createElement( "input" );
	_access_token.type = "hidden"
	_access_token.name = "_access_token"
	_access_token.value = "";
	document.querySelector( "#form_id-3255" ).appendChild( _access_token );

	select_a_destination.forEach( ( item, index ) => {

		item.addEventListener( "change", ( e ) => {

			console.log( e.target.value );

			if( e.target.checked ){
				switch( e.target.value ){
					case "stay_golden_rewards":
						_access_token.value += "39d5fca2-62ac-4f08-97f3-73b181deab1c,";
						break;
					case "the_spa_&_wellness":
						_access_token.value += "c60f2ec9-233f-4c44-937d-1220077e4a0e,";
						break;	
					case "dining_&_culinary":
						_access_token.value += "5cb5b192-b02b-4f14-b032-8c5fe38a331d,";
						break;
					case "meetings_&_conferences":
						_access_token.value += "f46fb21b-bf9d-4dbe-9599-383bdda38b22,";
						break;
					case "wedding_planning":	
						_access_token.value += "ad8f3b48-c14e-4982-9b11-5f3d57ebc768,";
						break;
				}
			}else{

				let value = _access_token.value;
				switch( e.target.value ){
					case "stay_golden_rewards":
						_access_token.value = value.replace("39d5fca2-62ac-4f08-97f3-73b181deab1c,", "") ;
						break;
					case "the_spa_&_wellness":
						_access_token.value = value.replace("c60f2ec9-233f-4c44-937d-1220077e4a0e,", "") ;
						break;	
					case "dining_&_culinary":
						_access_token.value = value.replace("5cb5b192-b02b-4f14-b032-8c5fe38a331d,", "") ;
						break;
					case "meetings_&_conferences":
						_access_token.value = value.replace("f46fb21b-bf9d-4dbe-9599-383bdda38b22,", "") ;
						break;
					case "wedding_planning":	
						_access_token.value = value.replace("ad8f3b48-c14e-4982-9b11-5f3d57ebc768,", "");
						break;	
				}		

			}

		} )

	} )
}	

(function(){

	if(!(window.ActiveXObject) && "ActiveXObject" in window) {

		//is explorer
		function msieversion() {

			var ua = window.navigator.userAgent;
			var msie = ua.indexOf("MSIE ");
			if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
			{
				const image_fit = document.getElementsByClassName('image-fit__wrapper');
				for(let i = 0; i < image_fit.length; i++ ){
					const this_image = image_fit[i].getElementsByTagName('img')[0];
					const image_data = this_image.dataset.srcset;
					const image_src = this_image.getAttribute('src');
					image_fit[i].classList.add('ie-bg');
					if(image_data){
						image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
					}else{
						image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
					}

				}
			}
			else
			{
				console.log('other browser');
			}

			return false;
		}

		msieversion();

	} else {
		/*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 /*****************************************************/
		var scrollParallax = []
		var scrolled = 0

		// screen height
		var v_height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;

		function doParallax(elm) {

			let boundes = elm.dataset.parallax.split(",") // get it from html
			//get distance in positive value
			let distance = Math.abs(boundes[0] - boundes[1])
			if (boundes[0] > boundes[1]) {
				//get distance in negative value (to do the scroll inverse)
				distance = distance * -1
			}
			//Equivalent distance using screen height + element height
			const unit_scroll = distance / (v_height + elm.offsetHeight)
			let temp = 0

			let topElement = 0;
			let element = elm;

			let id_elem = elm.dataset.parallaxid

			do {
				topElement += element.offsetTop || 0;
				element = element.offsetParent;
			} while (element)

			let parallaxFunction = function () {
				//Obtain the distance between top screen and document top 0
				scrolled = document.documentElement.scrollTop || window.pageYOffset
				//Distance of bottom page to top of the element
				let relative_distance = scrolled + v_height - topElement
				//transpoling data to move the parallax element relative to the scroll of all the screen
				temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				//console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
				elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			}

			scrollParallax[id_elem] = parallaxFunction

			window.addEventListener('scroll', scrollParallax[id_elem])

		}

		let observers_parallax = document.querySelectorAll(".js-parallax-element")

		if (observers_parallax) {
			let options_parallax = {
				root: null, // relative to document viewport
				rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
				threshold: 0 // visible amount of item shown in relation to root
			}

			function handler_parallax(entries, observer) {
				let entry;
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						doParallax(entry.target)
					} else {
						let id_elem = entry.target.dataset.parallaxid
						window.removeEventListener('scroll', scrollParallax[id_elem])
					}
				})
			}

			let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			let counter = 1
			observers_parallax.forEach(function (element) {
				observable_parallax.observe(element)
				element.dataset.parallaxid = counter
				counter++
			})
		}
		/********************************************************************************
		 END OF OBSERVER TO ADD PARALLAX EFFECT
		 ***********************************************************************************/
	}

	function closeNavItems( navItems ) {
		navItems.forEach( item => {

			item.nextElementSibling.classList.contains('active')
				? item.nextElementSibling.classList.remove('active')
				: null;

		});
	}

	$(".form-module-wrapper form").addClass('animate-fade top');
	$(".text-modules-wrapper .text-modules").addClass('animate-fade top');

	let BurgerMenu = document.getElementById('js_btn_menu');
	let NavigationBox = document.getElementById('navigationBox');
	let Body = document.body;
	let Header = document.getElementById('header');

	if(BurgerMenu){
		BurgerMenu.addEventListener('click', function(e){
			e.preventDefault();
			if(this.classList.contains("open")){
				this.classList.remove('open');
				this.querySelector('.text').textContent = 'Menu';
				NavigationBox.classList.remove('open');
				BookingBox.classList.remove('open');
				Body.classList.remove('scroll-no');
				Header.classList.remove('open');
				BtnBook.classList.remove('open');
				closeNavItems(document.querySelectorAll('#primary-nav li.sub-active>a'));
			} else {
				this.classList.add('open');
				this.querySelector('.text').textContent = 'Close';
				NavigationBox.classList.add('open');
				Body.classList.add('scroll-no');
				Header.classList.add('open');
			}
		});
	}

	let BtnBook = document.getElementById('js_btn_book');
	let BookingBox = document.getElementById('bookBox');

	if(BtnBook){
		BtnBook.addEventListener('click', function(e){
			e.preventDefault();
			this.classList.add('open');
			BurgerMenu.classList.add('open');
			BurgerMenu.querySelector('.text').textContent = 'Close';
			BookingBox.classList.add('open');
			Body.classList.add('scroll-no');
			Header.classList.add('open');
		});
	}

	$(document).ready(function () {
		// ==== Main Nav Dropdown
		if( document.querySelector('#primary-nav li') ) {
			
			let navigationItemsSubMenu = document.querySelectorAll('#primary-nav li.sub-active>a');
			let normalNavItems = document.querySelectorAll('#primary-nav > ul > li:not(.sub-active)');

			navigationItemsSubMenu.forEach( item => {
				item.addEventListener('click', ( e ) => {
					e.preventDefault();
					if( e.target.nextElementSibling && e.target.nextElementSibling.classList.contains('submenu')  ) {
						
						closeNavItems( navigationItemsSubMenu );

						let submenu = e.target.nextElementSibling;
						submenu.classList.add('active');
					}
				});
			});


			normalNavItems.forEach(( item ) => {
				item.addEventListener('mouseover', () => {
					closeNavItems( navigationItemsSubMenu );
				})
			})

		}
		// ==== END Main Nav Dropdown


		// $("#primary-nav li").hover(function(){
		// 	$(this).addClass("hover");
		// 	$('ul.submenu',this).fadeIn(200);
		// }, function(){
		// 	$(this).removeClass("hover");
		// 	$('ul.submenu',this).fadeOut(200);
		// });


		//To create after event
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		};

		$('#arriveInput').on('change', function(){
			start = $(this).val();
			$('.calendar-block').datepicker("setDate", start);
			$(this).attr('value', start);
		});

		$('#departureInput').on('change', function(){
			end = $(this).val();
			$('.calendar-block').datepicker("setDate", end);
			$(this).attr('value', end);
		});

		$('.calendar-block').datepicker({
			changeMonth: false,
			dateFormat: 'yy-mm-dd',
			numberOfMonths: 2,
			beforeShowDay: function (date) {
				$.datepicker._defaults.dateFormat = "yy-mm-dd";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				let arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				let departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				let selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					opencheck = 0;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
					opencheck = 1;
					firstClick = 0;
				}

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);

			},
			onChangeMonthYear: function () {
				opencheck = 1;
			}
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		let op = 0;
		function calendarRange(date){
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn--alt').val());
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut--alt').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-edge';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}
		function calendarSelect (date) {
			let start = ($('#CheckIn--alt').val() !== '') ? $('#CheckIn--alt').val() : $.datepicker.formatDate(DATE_FORMAT, new Date()),
				end = ($('#CheckOut--alt').val() !== '') ? $('#CheckOut--alt').val() : $.datepicker.formatDate(DATE_FORMAT, new Date());
			let startDate = $.datepicker.parseDate(DATE_FORMAT, start);
			let selectedDate = $.datepicker.parseDate(DATE_FORMAT, date);

			if ( op === 0 ) {
				op = 1;
				start = date;
				end =  date;
				$(this).val(start + ' - ');
				$(this).data().datepicker.inline = true;
			} else {
				op = 0;
				if(selectedDate <= startDate){
					end = start;
					start = date;
				} else {
					end =  date;
				}
				$(this).val(start + ' - ' + end);
				$(this).data().datepicker.inline = false;
			}
			$('#CheckIn--alt').val( start );
			$('#CheckOut--alt').val( end );
		}
		function calendarClose () {
			$(this).data().datepicker.inline = false;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = 'yy-mm-dd';
		$("#CheckInOut-home").datepicker({
			changeMonth: false,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: calendarRange,
			onSelect: calendarSelect,
			onClose: calendarClose
		});
		$("#CheckInOut-home").on('keyup', function(){
			const dates = $(this).val().split(' - ');
			$('#CheckIn--alt').val( dates[0] );
			$('#CheckOut--alt').val( dates[1] );
		});

		$("input[name=zip_code]").attr("maxlength", "5");
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};
}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let HeaderWeb = document.getElementById('header');
	let SubMenu = document.getElementById('subMenu');
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!HeaderWeb.classList.contains('down')){
				HeaderWeb.classList.add('down');
				HeaderWeb.classList.remove('up');
			}
		} else {
			// upscroll code
			if(!HeaderWeb.classList.contains('up')){
				HeaderWeb.classList.add('up');
				HeaderWeb.classList.remove('down');
			}
		}
	} else {
		if(HeaderWeb.classList.contains('up') || HeaderWeb.classList.contains('down')){
			HeaderWeb.classList.remove('up');
			HeaderWeb.classList.remove('down');
		}
	}
	if(SubMenu){
		let MenuSub = SubMenu.getElementsByClassName('sub-menu')[0];
		if(MenuSub){
			if(st > 470){
				MenuSub.classList.add('down');
			} else {
				MenuSub.classList.remove('down');
			}
		}
	}

	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}